module.exports = __webpack_public_path__ + "img/socupv2small.a4ed8a49.svg";